export const DASHBOARD_PAGE_NAME = "Dashboard";
export const DASHBOARD_TABLE_NAME = "All Audits";

export const DEFAULT_CHART_STATUS = "In QA";

// useTabStorage().getTab() returns 0 ("All") when nothing is stored yet, so a
// `getTab() ?? default` fallback never applies. Check the raw key instead so a
// fresh session starts on the default status.
export const getInitialStatusPosition = (tabStorage, filterOptions) => {
  const hasStoredTab = sessionStorage.getItem(`${window.location.pathname}_tab_storage`) !== null;
  return hasStoredTab ? tabStorage.getTab() : filterOptions.indexOf(DEFAULT_CHART_STATUS);
};
